import {
    Component,
    Input,
    HostListener,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-faq-data',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, MatIconModule, FormsModule, TranslateModule],
    templateUrl: './faq-data.component.html',
    styleUrl: './faq-data.component.scss',
})
export class FaqDataComponent implements OnInit {
    @Input() category: any;
    @Input() selectedLanguage: string = 'en';

    openSubcategory: any = null;
    openSubcategoryIndex: number | null = null;
    selectedQuestion: any = null;
    selectedQuestionIndex: number | null = null;
    isDesktop: boolean = window.innerWidth >= 768;
    searchTerm: string = '';

    constructor(private _route: ActivatedRoute) {}
    @HostListener('window:resize')
    onResize() {
        this.isDesktop = window.innerWidth >= 768;
    }

    ngOnInit() {
        this.openFirstQuestion();

        this._route.queryParams.subscribe((params) => {
            let question;
            question = params['q'];
            if (question) {
                this.searchFaq(question.replaceAll('-', ' '));
            }
        });
    }

    openFirstQuestion() {
        if (!this.category) return;

        if (this.category.subcategories?.length) {
            for (let i = 0; i < this.category.subcategories.length; i++) {
                const sub = this.category.subcategories[i];
                if (sub.faq?.length) {
                    this.openSubcategory = sub;
                    this.openSubcategoryIndex = i;
                    this.selectedQuestion = sub.faq[0];
                    this.selectedQuestionIndex = 0;
                    return;
                }
            }
        } else if (this.category.faq?.length) {
            this.selectedQuestion = this.category.faq[0];
            this.selectedQuestionIndex = 0;
        }
    }

    toggleSubcategory(subcategory: any, index: number) {
        if (this.openSubcategory === subcategory) {
            this.openSubcategory = null;
            this.openSubcategoryIndex = null;
        } else {
            this.openSubcategory = subcategory;
            this.openSubcategoryIndex = index;
        }
        this.selectedQuestion = null;
        this.selectedQuestionIndex = null;
    }

    toggleQuestion(faq: any, index: number) {
        if (this.selectedQuestion === faq) {
            this.selectedQuestion = null;
            this.selectedQuestionIndex = null;
        } else {
            this.selectedQuestion = faq;
            this.selectedQuestionIndex = index;
        }
    }

    searchFaq(keyword: string = '') {
        const lowerCaseSearch = keyword
            ? keyword.trim().toLowerCase()
            : this.searchTerm.trim().toLowerCase();

        if (!lowerCaseSearch) {
            this.openFirstQuestion();
            return;
        }

        this.openSubcategory = null;
        this.openSubcategoryIndex = null;
        this.selectedQuestion = null;
        this.selectedQuestionIndex = null;
        if (this.category?.subcategories?.length) {
            for (let i = 0; i < this.category.subcategories.length; i++) {
                const sub = this.category.subcategories[i];
                const matchingFaqIndex = sub.faq.findIndex((faq: any) =>
                    this.selectedLanguage == 'en'
                        ? faq.questionEn
                              .toLowerCase()
                              .includes(lowerCaseSearch) ||
                          faq.answerBm.toLowerCase().includes(lowerCaseSearch)
                        : faq.questionBm
                              .toLowerCase()
                              .includes(lowerCaseSearch) ||
                          faq.answerBm.toLowerCase().includes(lowerCaseSearch)
                );

                if (matchingFaqIndex !== -1) {
                    this.openSubcategory = sub;
                    this.openSubcategoryIndex = i;
                    this.selectedQuestion = sub.faq[matchingFaqIndex];
                    this.selectedQuestionIndex = matchingFaqIndex;
                    return;
                }
            }
        }

        if (this.category?.faq?.length) {
            const matchingFaqIndex = this.category.faq.findIndex((faq: any) =>
                this.selectedLanguage == 'en'
                    ? faq.questionEn.toLowerCase().includes(lowerCaseSearch) ||
                      faq.answerEn.toLowerCase().includes(lowerCaseSearch)
                    : faq.questionBm.toLowerCase().includes(lowerCaseSearch) ||
                      faq.answerBm.toLowerCase().includes(lowerCaseSearch)
            );
            if (matchingFaqIndex !== -1) {
                this.selectedQuestion = this.category.faq[matchingFaqIndex];
                this.selectedQuestionIndex = matchingFaqIndex;
            }
        }
    }
}
